import React from "react";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import { Colors } from "../../Styles/Colors";

export function ClickableCard({
  isSelected,
  icon,
  label,
  labelTwo,
  onClick,
  alt,
  testID,
  disable,
  width,
  height,
}) {
  const iconSrc = icon?.default ?? icon;
  return (
    <Button
      emed_tid={testID}
      className="eMed_Click_card_hover"
      disabled={disable}
      sx={{ textTransform: "none" }}
    >
      <Card
        elevation={3}
        onClick={() => onClick?.()}
        className="eMed_Clickable_card"
        sx={{ backgroundColor: isSelected ? Colors.ThemeColor : "" }}
      >
        <div className="eMed_Clickable_card_inner" style={{ color: isSelected ? "white" : "" }}>
          <div>
            <img
              style={{ width: width || "2vw", height: height || "2vw", display: "block" }}
              src={iconSrc}
              alt={alt || label}
            />
          </div>
          <div className="eMed_Clickable_label">
            {label}
          </div>
          {labelTwo ? (
            <div className="eMed_Clickable_label">
              {labelTwo}
            </div>
          ) : null}
        </div>
      </Card>
    </Button>
  );
}

/** Stub: returns view/edit access. Replace with full logic from CommonFunctions when needed. */
export function CheckAccessFunc(Module, MenuName, TabName = null, SubTabName = null, Type) {
  return { viewAccess: true, editAccess: true, title: "" };
}
